import { BaseAction } from "../../../core/actions/BaseAction";
import { IBookedOffer, IBookingTypeTrip } from "../../../Orchestrator/Types/Index";
import { IGetAllTripWithoutExchangeActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/FilterTripAction";


export class GetAllTripWithoutExchangeAction extends BaseAction<IBookingTypeTrip[], IGetAllTripWithoutExchangeActionParams> {

    override async run(): Promise<IBookingTypeTrip[]> {
        let allBookedOfferWithoutExchange: IBookingTypeTrip[] = []
        try {
            const { bookedOffers, trips } = this.params!
            const allTripCoverageIds = bookedOffers.map(offer => offer?.tripCoverage?.coveredTripId)
            const allTripWithoutExchange: IBookingTypeTrip[] = trips.filter(trip => allTripCoverageIds.includes(trip.id))
            allBookedOfferWithoutExchange = allTripWithoutExchange
        } catch (error: any) {
            console.error("Error fetching Data:", error);
        } finally {
            return allBookedOfferWithoutExchange
        }
    }
}

export const getAllTripWithoutExchangeAction = new GetAllTripWithoutExchangeAction()